import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Page from '@lib/components/v2/Page';
import { DOCUMENTS } from '@js/lib/constants/documents';
import { localizedString } from '@languages';
import { Title } from '@lib/components/v2/Title';
import { useCapture } from '@lib/components/v2/Capture/useCapture';
import classes from './CaptureNSWDigitalDriverLicenceScreen.style.module.scss';

export const CaptureNSWDigitalDriverLicenceScreen = ({
  onCloseScreen = () => {},
  onUploadDigitalImage = () => {}
}) => {
  const capture = useCapture(handleFileSelected);

  const footerButtons = [
    {
      label: localizedString('back'),
      variant: 'transparent',
      onClick: onCloseScreen
    },
    {
      label: localizedString('capture.FLOW_V2_CAPTURE_DIGITAL_UPLOAD_BUTTON_TITLE'),
      type: 'submit',
      onClick: capture
    }
  ];

  return (
    <Page buttons={footerButtons}>
      <div style={{ height: '100%' }}>
        <Title title={localizedString('capture.FLOW_V2_CAPTURE_DIGITAL_HEADING')} />

        <div className={classes.description}>{localizedString('plasticCardPreferred')}</div>

        <div className={classes.instructionList}>
          <div className={classes.item}>
            <div className={classes.instructionNumber}>1.</div>
            <div className={classes.instructionText}>{localizedString('goToServiceNsw')}</div>
            <a
              className={classes.linkToSNSW}
              rel="noreferrer"
              target="_blank"
              href="https://www.service.nsw.gov.au/campaign/service-nsw-mobile-app"
            >
              {localizedString('openSNSW')}
            </a>
          </div>
          <div className={classes.item}>
            <div className={classes.instructionNumber}>2.</div>
            <div className={classes.instructionText}>{localizedString('takeScreenshot')}</div>
          </div>
          <div className={classes.item}>
            <div className={classes.instructionNumber}>3.</div>
            <div className={classes.instructionText}>
              {parse(localizedString('comeBackToScreenAndUploadScreenshot'))}
            </div>
          </div>
          <div className={classes.item}>
            <div className={classes.instructionNumber}>4.</div>
            <div className={classes.instructionText}>
              {parse(localizedString('youWillNeedToEnterManually'))}
            </div>
          </div>
        </div>
      </div>
    </Page>
  );

  function handleFileSelected(e) {
    const imageFile = e.target.files[0];
    if (!imageFile) {
      return;
    }

    onUploadDigitalImage({ imageFile, idType: DOCUMENTS.DIGITAL_DRIVER_LICENCE.documentType });
  }
};

CaptureNSWDigitalDriverLicenceScreen.propTypes = {
  onCloseScreen: PropTypes.func,
  onUploadDigitalImage: PropTypes.func
};
